import Crud from '../components/Exposition/Crud'
import Add from '../components/Exposition/Add'
import Edit from '../components/Exposition/Edit'

let routes = {
    path: '/exposition',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/exposition',
            component: Crud
        },
        {
            path: '/exposition/add',
            component: Add
        },
        {
            path: '/exposition/edit/:id',
            component: Edit
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/exposition.js